import {getFetcherWithResponse, callIfFunction} from '@startlibs/utils'
import {useToggle} from '@startlibs/core'
import {authGetFetcher, jwtGetFetcher, jwtPostFetcher} from './authFetch'

const isSafeUrl = (url) => {
  try {
    const parsed = new URL(url, window.location.origin)
    return ['http:', 'https:'].includes(parsed.protocol)
  } catch {
    return false
  }
}

const safeRedirect = (target, url) => {
  if (isSafeUrl(url)) {
    target.location.href = url
  } else {
    console.error('Blocked unsafe redirect URL:', url)
  }
}

export const downloadFile = (launchURL) => {
  if (window.navigator && window.navigator.msSaveBlob) {
    safeRedirect(window, launchURL)
  } else {
    const link = document.createElement('a')
    link.href = launchURL
    link.style.visibility = "hidden"
    link.setAttribute("download", "")
    document.body.appendChild(link);
    link.click()
    link.remove()
  }
}

var getOrigin = function (href) {
  const [protocol, , host] = href.split("/")
  return protocol + "//" + host;
};

export const checkForDownload = (url) => new Promise((res, rej) => {
  let tries = 0;
  if (window.xdomain) {
    const origin = getOrigin(url)
    window.xdomain.slaves({
      [origin]: "/public/proxy.html"
    })
  }
  const check = () => getFetcherWithResponse(url, null, {method: 'HEAD'})
    .then(([, response]) => response.status === 200 ? res(url) : setTimeout(check, 1000))
    .catch(([req, response]) => {
      if (!response) {
        tries++;
        if (tries > 5) {
          rej(response)
        } else {
          setTimeout(check, 1000)
        }
      } else if (response.status === 404) {
        rej(response.status)
        console.log('missing file')
      } else if (response.status === 500) {
        rej(response.status)
        console.log('server error')
      } else {
        rej(response.status)
      }
    })
  check()
})


export const useDownload = (jwt, params) => {

  const loading = useToggle()
  const started = useToggle()
  const downloadError = useToggle()

  const download = () => {
    downloadError.close()
    loading.wait(
      jwtPostFetcher(callIfFunction(jwt))(`/api/downloadLink`, params)
        // .then(({url}) => checkForDownload(url))
        .then(({url}) => downloadFile(url))
        // .then(downloadFile)
    ).then(() => {
        started.open();
        started.closeAfter(1500);
      })
      .catch(downloadError.open)
  }

  return [download, loading.isOpen, started.isOpen, downloadError.isOpen]
}

export const useViewStudy = (jwt, studyUIDs) => {

  const loading = useToggle()

  const openViewer = () => {
    const wi = window.open('about:blank', '_blank')
    loading.wait(
      jwtGetFetcher(callIfFunction(jwt))(`/api/viewerLink?studyUids=${studyUIDs.join("|")}`)
        .then(({viewerURL}) => {
          safeRedirect(wi, viewerURL);
        })
        .catch(wi.close)
    )
  }

  return [openViewer, loading.isOpen]
}

export const useViewNonDicom = (jwt, attachment, requestId, shortAuthToken = (requestId) => jwtGetFetcher(callIfFunction(jwt))(`/api/shortAuthToken`,{requestId: requestId})) => {

  const loading = useToggle()
  const openViewer = () => {
    loading.wait(
      shortAuthToken(requestId)
        .then((response) => {
          const wi = window.open('about:blank', '_blank')
          safeRedirect(wi, `/api/viewNonDicom?file=${encodeURIComponent(attachment.uid + (attachment.fileExtension ? "." : "") + attachment.fileExtension)}&t=${callIfFunction(response.jwt)}`);
        })
        // .catch(wi.close)
    )
  }

  return [openViewer, loading.isOpen]
}